import { useAuth } from '@/lib/auth';
import './EmailLoginForm.scss';
import { ReactComponent as Logo } from '@/assets/img/p-logo-r.svg';
import { ReactComponent as PasswordShowIcon } from '@/assets/img/password-show-icon.svg';
import { ReactComponent as BackIcon } from '@/assets/img/pet-back-arrow.svg';
import { ReactComponent as PasswordHideIcon } from '@/assets/img/password-hide-icon.svg';
import { ChangeEvent, useEffect, useState } from 'react';
import { showNotification } from '@/utils/notificationUtils';
import Utils from '@/utils/util';
import PhoneInput from 'react-phone-input-2';
import { Loader } from '@/components/Loader/Loader';
import { useNavigate } from 'react-router-dom';
import { forgotPasswordandReset } from '../api/forgotPassword';
import { API_URL, ENABLE_GOOGLE_CONVERSION, SUPER_ADMIN_ROLE } from '@/config';
import OTPInput, { ResendOTP } from 'otp-input-react';

import { Button } from '@/components/Elements';
import { useOTPLogin, useOtpVerify } from '../api/otpLogin';
import { registerWithEmailAndPassword } from '../api/register';
import { useUpdatePassword } from '../api/updatePassword';
import storage from '@/utils/storage';
type UserData = {
  email: string;
  phone: string;
  password: string;
  confirmPassword: string;
  firstName: string;
  lastName: string;
};

type LoginFormProps = {
  onBack: () => void;
  onLoginSuccess: (data: any) => void;
};

export const OTPSignupFlow = ({ onBack, onLoginSuccess }: LoginFormProps) => {
  const { login, register } = useAuth();
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isSignUp, setIsSignup] = useState<boolean>(true);
  const [forgotPassword, setForgotPassword] = useState<boolean>(false);
  const [email, setEmail] = useState('');
  const [loginType, setLoginType] = useState('otp');
  const useOTPLoginMutation = useOTPLogin();
  const useOtpVerifyMutaion = useOtpVerify();
  const [otpScreenData, setEnterOtpScreen] = useState<any>(null);
  const [otp, setOtp] = useState('');
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [selectedType, setType] = useState('');
  const updatePasswordMutation = useUpdatePassword();

  const [userData, setUserData] = useState<UserData>({
    email: '',
    phone: '',
    password: '',
    confirmPassword: '',
    firstName: '',
    lastName: '',
  });

  useEffect(() => {
    Utils.scrollToTop();
  }, []);

  const handleFormChange = (formFieldName: string, value: string) => {
    userData[formFieldName as keyof typeof userData] = value;
    setUserData({ ...userData });
  };

  const extractUrlParams = (extend = false) => {
    const urlParams = new URLSearchParams(window.location.search);
    const params: any = {};
    urlParams.forEach((value, key) => {
      params[key] = value;
    });
    if (extend) {
      params.app_url = window.location.href;
      params.referrer_url = document.referrer;
    }
    return params;
  };

  const validate = () => {
    const { email, password, confirmPassword, phone, firstName, lastName } = userData;
    if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      showNotification({
        type: 'info',
        title: 'Please enter a valid email',
      });

      return false;
    }

    return true;
  };
  const onRegister = async () => {
    const { email, password, confirmPassword, phone, firstName, lastName } = userData;

    if (validate()) {
      setIsLoading(true);
      if (isSignUp) {
        try {
          const res = await registerWithEmailAndPassword({
            email,
            password,
            confirmPassword,
            firstName,
            lastName,
            loginType,
          });
          if (res) {
            const windowRef: any = window;
            if (res.isFirstTimeSignup && ENABLE_GOOGLE_CONVERSION === 'yes' && windowRef?.fbq) {
              const urlParams = extractUrlParams();
              urlParams.promoCode && storage.setKey(`promoCode`, urlParams.promoCode);
              windowRef?.fbq('track', 'Signup', {
                email: res.email,
                subscriptionType:
                  res?.subscriptionDetails?.productName === 'Petsked Premium' ? 'Paid' : 'Free',
              });
              //windowRef?.fbq('track', 'Subscribe', { contents: [{ email: res.email, subscriptionType: res?.subscriptionDetails?.productName === 'Petsked Premium' ? 'Paid' : 'Free' }] });
            }
            if (res.isFirstTimeSignup && windowRef.gtag && ENABLE_GOOGLE_CONVERSION === 'yes') {
              const urlParams = extractUrlParams();
              const options = { user_email: res.email, ...urlParams };
              urlParams.promoCode && storage.setKey(`promoCode`, urlParams.promoCode);

              windowRef.gtag('event', 'conversion', {
                send_to: 'AW-16550157434/TmK6CLnhwq8ZEPq43dM9',
              });
              windowRef.gtag('event', 'petsked_signup', {
                user_email: res.email,
                user_utm_campaign: options.utm_campaign,
                user_utm_source: options.utm_source,
                user_utm_medium: options.utm_medium,
                user_referrer: options.referrer,
              });
            }
            generateOtp(res?.email);
          } else {
            setIsLoading(false);
          }
        } catch (error) {
          setIsLoading(false);
        }
      }
    }
  };

  const generateOtp = async (emailId?: any) => {
    try {
      if (loginType === 'otp') {
        const res = await useOTPLoginMutation.mutateAsync({ email: emailId });
        if (res) {
          setEnterOtpScreen(res);
          setIsLoading(false);
          showNotification({
            type: 'success',
            title: 'Otp sent successfully on your email',
          });
        } else {
          showNotification({
            type: 'error',
            title: 'Invalid email.',
          });
          setIsLoading(false);
        }
      }
    } catch (error) {
      setIsLoading(false);
    }
  };

  const onVerifyOtp = async () => {
    const { email } = userData;

    if (!otp || otp.trim().length < 6) {
      showNotification({
        type: 'info',
        title: 'Please enter 6 digit code',
      });
      return false;
    } else {
      setIsLoading(true);
      try {
        const res = await useOtpVerifyMutaion.mutateAsync({ email: email, otp });
        if (res) {
          setIsOtpVerified(true);
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        setIsLoading(false);
      }
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (otpScreenData && !isOtpVerified) {
        onVerifyOtp();
      } else if (!otpScreenData) {
        onRegister();
      } else if (isOtpVerified) {
        // If password fields are filled, set password, otherwise skip
        if (userData.password || userData.confirmPassword) {
          setPassword('setpassword');
          setType('password');
        } else {
          setPassword('otp');
          setType('otp');
        }
      }
    }
  };

  const validatePassword = () => {
    const { email, password, confirmPassword, phone, firstName, lastName } = userData;
    if (!password && loginType === 'password') {
      showNotification({
        type: 'info',
        title: 'Please enter a password',
      });
      return false;
    }
    if (password && password.length < 8) {
      showNotification({
        type: 'info',
        title: 'Password length should be at least 8 characters.',
      });
      return false;
    }
    if (!confirmPassword || password !== confirmPassword) {
      showNotification({
        type: 'info',
        title: 'Passwords do not match',
      });
      return false;
    }
    return true;
  };

  const setPassword = async (type?: string) => {
    const urlParams = extractUrlParams();
    urlParams.promoCode && storage.setKey(`promoCode`, urlParams.promoCode);
    if (type === 'otp') {
      setIsLoading(true);
      const res = await login({
        email: otpScreenData?.email,
        otp,
      });
      if (res) {
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    } else {
      if (validatePassword()) {
        setIsLoading(true);
        const { email, password, confirmPassword, phone, firstName, lastName } = userData;
        await updatePasswordMutation.mutateAsync({
          password,
          confirmPassword,
          email: otpScreenData?.email,
        });
        const res = await login({
          email,
          otp,
        });
        if (res) {
          setIsLoading(false);
        } else {
          setIsLoading(false);
        }
      }
    }
  };

  return (
    <div className="email-login-form" onKeyDown={handleKeyDown} role="presentation">
      <section className="consumer-login">
        {otpScreenData && !isOtpVerified ? (
          <div className="registration-container">
            <BackIcon
              onClick={() => {
                if (otpScreenData) {
                  setEnterOtpScreen(null);
                } else {
                  onBack();
                }
              }}
              className="back-svg"
            />
            <div className="logo-section">
              <Logo /> <p className="petsked-desc h2">Verify Email </p>
              <p className="petsked-desc">
                Enter the 6-digit code sent to you at {otpScreenData?.email}
              </p>
            </div>

            <div className="otp-input-container">
              <OTPInput
                value={otp}
                onChange={setOtp}
                autoFocus
                OTPLength={6}
                otpType="number"
                className="otp-input-root"
                inputClassName="otp-input"
                disabled={false}
                secure
              />
            </div>

            <div className="logo-section mt-5">
              {useOTPLoginMutation.isLoading ? (
                <>
                  <span className="petsked-desc pink">Sending...</span>
                </>
              ) : (
                <a
                  className="petsked-desc pink"
                  onClick={async () => {
                    await useOTPLoginMutation.mutateAsync({
                      email: otpScreenData?.email,
                    });
                  }}
                >
                  Resend code
                </a>
              )}
            </div>
            <div className="petsked-form">
              <div className="action">
                <button
                  className="petsked-button button-dark"
                  onClick={onVerifyOtp}
                  disabled={isLoading}
                >
                  {isLoading ? <Loader text="Signing up..." /> : <span>{'Sign In'}</span>}
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="registration-container">
            {/* <div className='back-icon-div'> */}
            {!isOtpVerified && (
              <BackIcon
                onClick={() => {
                  if (forgotPassword || isSignUp) {
                    setForgotPassword(false);
                    setIsSignup(false);
                  } else {
                    onBack();
                  }
                }}
                className="back-svg"
              />
            )}
            <div className="logo-section">
              <Logo />
              <p className="petsked-desc">Get started, create a new account</p>
            </div>
            <div className="petsked-form">
              {!isOtpVerified && (
                <>
                  <input
                    id="customer-mail"
                    type="email"
                    value={userData.email}
                    onChange={(e: ChangeEvent<HTMLInputElement>) =>
                      handleFormChange('email', e.target.value)
                    }
                    placeholder="Enter your email"
                    autoComplete="off"
                  />

                  <div className="set-display">
                    <input
                      id="firstName"
                      type="email"
                      value={userData.firstName}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleFormChange('firstName', e.target.value)
                      }
                      placeholder="First name"
                      autoComplete="off"
                    />
                    <input
                      id="lastName"
                      type="email"
                      value={userData.lastName}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleFormChange('lastName', e.target.value)
                      }
                      placeholder="Last name"
                      autoComplete="off"
                    />
                  </div>
                </>
              )}
              {isOtpVerified && (
                <>
                  <span className="form-field-wrapper">
                    <input
                      id="customer-secret"
                      type={showPassword ? 'text' : 'password'}
                      value={userData.password}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleFormChange('password', e.target.value)
                      }
                      placeholder="Password"
                      autoComplete="off"
                    />
                    {showPassword ? (
                      <PasswordHideIcon onClick={() => setShowPassword(!showPassword)} />
                    ) : (
                      <PasswordShowIcon onClick={() => setShowPassword(!showPassword)} />
                    )}
                  </span>
                  <span className="form-field-wrapper">
                    <input
                      id="customer-secret"
                      type={showConfirmPassword ? 'text' : 'password'}
                      value={userData.confirmPassword}
                      onChange={(e: ChangeEvent<HTMLInputElement>) =>
                        handleFormChange('confirmPassword', e.target.value)
                      }
                      placeholder="Confirm Password"
                      autoComplete="off"
                    />
                    {showConfirmPassword ? (
                      <PasswordHideIcon
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      />
                    ) : (
                      <PasswordShowIcon
                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                      />
                    )}
                  </span>
                </>
              )}

              {isOtpVerified && (
                <div className="action dsiplay-flex">
                  <button
                    className="petsked-button button-notification width-sign-150"
                    onClick={() => {
                      setPassword('otp');
                      setType('otp');
                    }}
                    disabled={isLoading}
                  >
                    {isLoading && selectedType === 'otp' ? (
                      <Loader text="Skip" />
                    ) : (
                      <span>{'Skip'}</span>
                    )}
                  </button>
                  <button
                    className="petsked-button button-dark width-sign-250"
                    onClick={() => {
                      setPassword('setpassword');
                      setType('password');
                    }}
                    disabled={isLoading}
                  >
                    {isLoading && selectedType === 'password' ? (
                      <Loader text="Signing in..." />
                    ) : (
                      <span>{'Sign In'}</span>
                    )}
                  </button>
                </div>
              )}

              {!isOtpVerified ? (
                <div className="action ">
                  <button
                    className="petsked-button button-dark"
                    onClick={() => {
                      onRegister();
                    }}
                    disabled={isLoading}
                  >
                    {isLoading ? <Loader text="Signing up..." /> : <span>{'Continue'}</span>}
                  </button>
                  <p className="terms">
                    By continuing, you agree to our <b>Terms</b> and <b>Privacy Policy</b>, and to
                    receive emails and updates.
                  </p>{' '}
                  <p className={`sign-up-link signup`}>
                    Have an account?{' '}
                    <a
                      onClick={() => {
                        onBack();
                      }}
                    >
                      {'Sign In Now'}
                    </a>
                  </p>
                </div>
              ) : (
                <div className="action">
                  <p className="terms">
                    You can set a password here for login, or you can skip this step and log in
                    using OTP whenever needed.
                  </p>
                </div>
              )}
            </div>
          </div>
        )}
      </section>
    </div>
  );
};
